<template>
  <base-card
    :heading="heading"
    :scrollable="displayArt ? false : true"
    :icons="['']"
  >
    <img :src="notFoundArt" alt="No events found" v-if="displayArt" />
    <event-list-item
      v-for="event in events"
      :key="event.userId"
      :event="event"
      @click="navigateToEvent(event)"
    />
  </base-card>
</template>
<script>
import EventListItem from "./UI/ListItems/Event/ContactLocationEventDetails.vue";
import BaseCard from "./UI/BaseCard.vue";
export default {
  data() {
    return {
      notFoundArt: require("./UI/Illustrations/MarsDJNoEventsHere.png"),
    };
  },
  computed: {
    displayArt() {
      if (this.contact) {
        return !this.contact.eventsRetrieved && this.events.length === 0;
      }
      return this.$store.state.eventsRetrieved && this.events.length === 0;
    },
    events() {
      return this.$store.getters.events("future", (a, b) => {
        let startTime = (event) => {
          switch (event.api_version) {
            case "9-28-2022":
              return new Date(event.start_time).getTime();
            default:
              return new Date(event.data.startTime).getTime();
          }
        };
        let aStart = startTime(a);
        let bStart = startTime(b);
        return aStart < bStart ? -1 : aStart > bStart ? 1 : 0;
      });
    },
  },
  methods: {
    navigateToEvent(event) {
      this.$store.state.event = event;
      this.$router.push(`/event/${event.tenantId}/${event.userId}`);
    },
  },
  components: { EventListItem, BaseCard },
  props: ["heading", "contact"],
};
</script>

<style scoped>
img {
  max-width: 100%;
  height: 100%;
  object-fit: contain;
  margin: auto;
}
</style>
